module.exports = __webpack_public_path__ + "images/attendance.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/attendance.jpg
 ** module id = 50
 ** module chunks = 1
 **/